import { render, staticRenderFns } from "./AttachDuplicateDlg.vue?vue&type=template&id=0da68b5a"
import script from "./AttachDuplicateDlg.vue?vue&type=script&lang=js"
export * from "./AttachDuplicateDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports